import * as _ from "lodash";
import * as React from 'react';

import { PlaylistUploadDto } from 'collaboration-service';
import { getPath } from 'services/Helpers';
import { PlaylistEditActions, useDispatchPLE, useSelectorPLE } from './PlaylistEdit';

export const usePLEState = <T extends any = any>(getter: (item: PlaylistUploadDto) => T): {
    value: T,
    setValue: (val: T | ((val: T) => T), force?: boolean) => void,
    addFile: (lng?: string, selectMediaForLng?: string[]) => void,
    addFileTo: (nameStack: string[], lng?: string, selectMediaForLng?: string[]) => void,
    resetValue: () => void,
    clonedValue: () => T,
    originalValue: T,
} => {
    const nameStack = React.useMemo(() => getPath(getter as any), [getter]);
    //console.log('nameStack => ', nameStack);
    //console.log('getter.toString() => ', getter.toString());
    const post = useSelectorPLE(s => s.playlist);
    const originalPost = useSelectorPLE(s => s.originalPlaylist);
    const d = useDispatchPLE();
    const setValue = React.useMemo(() => (val: T | ((val: T) => T), force?: boolean) => d(PlaylistEditActions.setValue(nameStack, val, force)), [nameStack, d]);
    const value = React.useMemo(() => {
        let cur: any = post;
        _.forEach(nameStack, ns => {
            cur = (cur as any)[ns];
        });
        return cur as T;
    }, [post, nameStack]);
    const originalValue = React.useMemo(() => {
        let cur: any = originalPost;
        _.forEach(nameStack, ns => {
            cur = (cur as any)[ns];
        });
        return cur as T;
    }, [originalPost, nameStack]);

    const addFile = React.useMemo(() => (lng?: string, selectMediaForLng?: string[]) => {
        d(PlaylistEditActions.addFile(nameStack, lng, selectMediaForLng));
    }, [d, nameStack]);
    const addFileTo = React.useMemo(() => (ns: string[], lng?: string, selectMediaForLng?: string[]) => {
        d(PlaylistEditActions.addFile([...nameStack, ...ns], lng, selectMediaForLng));
    }, [d, nameStack]);
    const resetValue = React.useMemo(() => () => {
        d(PlaylistEditActions.resetValue(nameStack));
    }, [nameStack, d]);
    const clonedValue = React.useMemo(() => () => {
        const cloned = _.cloneDeep(value);
        return cloned;
    }, [value]);
    return { value, setValue, addFile, addFileTo, resetValue, originalValue, clonedValue };
};
